import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type GroupBase } from "react-select";
import { getTimeBeforeShowLabel } from "userTask/beforeShowLabelHelper";

interface Props {
  isRelativeDeadline: boolean
  value: number
  onChangeDays: (days: number) => void
  onIsNoLongerRelativeDeadline: () => void
}

interface DeadlineOption {
  value: number
  label: string
};

const preciseDateOption = { value: undefined, label: RESX.DateTime.PreciseDate };

const generateOptions = (): Array<GroupBase<DeadlineOption>> => {
  const beforeOptions: DeadlineOption[] = [];
  // beforeOptions.push({ value: 0, label: RESX.DateTime.PreciseDate });

  for (let i = 0; i < 3; i++) {
    const days = i + 1;
    beforeOptions.push({
      value: -days,
      label: getTimeBeforeShowLabel(-days)
    });
  }

  for (let i = 3; i < 13; i++) {
    const days = i + 1;
    beforeOptions.push({
      value: -days,
      label: getTimeBeforeShowLabel(-days)
    });
  }

  for (let i = 1; i < 20; i++) {
    const weeks = i + 1;
    const days = weeks * 7;
    beforeOptions.push({
      value: -days,
      label: getTimeBeforeShowLabel(-days)
    });
  }

  const afterOptions = beforeOptions.map<DeadlineOption>(o => ({ value: -o.value, label: getTimeBeforeShowLabel(-o.value) }));

  return [
    {
      label: undefined,
      options: [preciseDateOption]
    },
    {
      label: RESX.DateTime.On,
      options: [{ value: 0, label: getTimeBeforeShowLabel(0) }]
    },
    {
      label: RESX.DateTime.Before,
      options: beforeOptions
    }, {
      label: RESX.DateTime.After,
      options: afterOptions
    }
  ];
};

const options = generateOptions();

const DeadlineOptionsDropdown = (props: Props) => {
  const selectedValue = React.useMemo(() => {
    if (!props.isRelativeDeadline) return preciseDateOption;
    else return options.flatMap(o => o.options).find(o => o.value === props.value);
  }, [props.value, props.isRelativeDeadline]);

  return <BaseReactSelectDropdown<DeadlineOption>
    excludeKeys={undefined}
    getLabel={o => o.label}
    getValue={o => o.value}
    value={selectedValue}
    onChange={v => {
      if (v.value == null) props.onIsNoLongerRelativeDeadline();
      else props.onChangeDays(v.value);
    }}
    options={options}
    config={{
      isSearchable: false
    }}
  />;
};

export default DeadlineOptionsDropdown;